import * as React from 'react';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import { useParams } from 'js/lib/useRouter';

import DegreesConversionExperiments from 'bundles/epic/clients/DegreesConversion';

const COURSERA_HOSTED_PROGRAM_TRACKER = 'https://www.coursera-apply.org/ping';

const PROGRAM_TO_TRACKER_MAP: Record<string, string> = {
  'emba-iitr': COURSERA_HOSTED_PROGRAM_TRACKER,
  'statistics-data-analytics-pgdip-isi': COURSERA_HOSTED_PROGRAM_TRACKER,
  'bachelor-of-science-computer-science-bits': COURSERA_HOSTED_PROGRAM_TRACKER,
  'msm-digital-transformation-healthcare-northeastern': COURSERA_HOSTED_PROGRAM_TRACKER,
  'bachelor-of-science-data-science-ai-iitguwahati': COURSERA_HOSTED_PROGRAM_TRACKER,
  'mba-business-analytics-jgu': COURSERA_HOSTED_PROGRAM_TRACKER,
  'ma-public-policy-jgu': COURSERA_HOSTED_PROGRAM_TRACKER,
  'ma-international-relations-security-strategy-jgu': COURSERA_HOSTED_PROGRAM_TRACKER,
  'pgdm-spjimr': COURSERA_HOSTED_PROGRAM_TRACKER,
  'mcit-penn': 'https://online-education.seas.upenn.edu/ping',
  'meng-computer-engineering-dartmouth': 'https://apply.gs.dartmouth.edu/ping',
};

/**
 * Ping tracker is Slate's analytics service. It is used for degree attribution for when the application is hosted on Slate.
 * For more info see https://docs.google.com/document/d/1knAL8Px5XzC0aX3PvERkpJH15mnoFZCIGVANTwKbVKI.
 */
const PingTracker = () => {
  const { slug } = useParams();
  const [trackerLink, setTrackerLink] = useState<string | undefined>();

  useEffect(() => {
    const isEpicEnabled = DegreesConversionExperiments.get(
      'shouldEnablePingTracker',
      // eslint-disable-next-line camelcase
      // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      { product_id: slug }
    );

    if (isEpicEnabled) {
      // @ts-expect-error TS2538 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      setTrackerLink(PROGRAM_TO_TRACKER_MAP[slug]);
    }
  }, [slug]);

  if (!trackerLink) {
    return null;
  }

  return (
    <Helmet>
      <script async={true} src={trackerLink} />
    </Helmet>
  );
};

export default PingTracker;
